import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const Toggle = styled.div`
  display: inline-flex;
  border-radius: 20px;
  background: ${props => props.theme.colors.bgTertiary};
  border: 1px solid ${props => props.theme.colors.border};
  padding: 2px;
`;

const Btn = styled.button`
  padding: 4px 10px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: ${props => props.theme.fonts.main};
  transition: all 0.2s;

  ${props => props.$active ? `
    background: ${props.theme.colors.primary};
    color: ${props.theme.colors.bgPrimary};
  ` : `
    background: transparent;
    color: ${props.theme.colors.textMuted};
    &:hover { color: ${props.theme.colors.text}; }
  `}
`;

const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();

  return (
    <Toggle>
      <Btn $active={lang === 'ja'} onClick={() => setLang('ja')}>JP</Btn>
      <Btn $active={lang === 'en'} onClick={() => setLang('en')}>EN</Btn>
    </Toggle>
  );
};

export default LanguageToggle;
